module.exports = __webpack_public_path__ + "img/2-17.c5af384a.jpg";